import { ISpellingExemption, ISpellingExemptionGetResponse } from "@edgetier/watchtower-types";

/**
 * Update the react query cache with the updated spelling exemption details.
 * @param spellingExemption
 * @param cachedSpellingExemptions The spelling exemptions in the cache.
 * @returns An updated object containing the new exemption's information.
 */
export const updateSpellingExemptionCache = (spellingExemption: ISpellingExemption) => (
    cachedSpellingExemptions: ISpellingExemptionGetResponse | undefined
) => {
    const pagination = cachedSpellingExemptions?.pagination ?? { nextPage: null, previousPage: null };
    const newSpellingExemptions = (cachedSpellingExemptions?.items ?? []).map((queryExemption) =>
        spellingExemption.spellingExemptionId === queryExemption.spellingExemptionId
            ? { ...queryExemption, ...spellingExemption }
            : queryExemption
    );
    return {
        pagination,
        items: newSpellingExemptions,
    };
};
